import { useBranding } from "../../../contexts/branding";

export function AppLogo() {
    const { logoUrl, label } = useBranding();
    return (
        <img
            className={label === "HabitNu" ? "app-logo-small" : "app-logo-large"}
            src={logoUrl}
            alt="logo"
        />
    );
}
